var mapContainer;
var markerClusterer;
var markers = [];

Alpine.data('SearchPageWithAlpineJs', () => ({
    results: [],
    recommendation: [],
    other_locations: [],
    mapPins: [],
    featuredProperty: null,
    banners: [],
    loadingMapPins: false,
    expandOnMobile: false,
    countryCode: window.global.country_code,
    type: 'list',
    loading: true,
    expanded: false,
    title: 'UAE',
    openPropertyModal: false,
    show_other_locations: false,
    selectedProject: null,
    limit: 2, // how many to show when collapsed
    otherLocationLoading: true,
    init() {
        var _self = this;

        _self.$nextTick(async () => {

            _self.fetchFeaturedListing();

            var allParams = [];
            var projectLocation = [];
            const hasParams = new URLSearchParams(window.location.search);


            if (hasParams.size > 0) {
                allParams = _self.getQueryStrings(); // all
                projectLocation = _self.getQueryStrings('projectOrLocationSelection[0]'); // specific
                this.title = (projectLocation.length > 0 ? projectLocation[0] : 'UAE');
            }
            _self.show_other_locations = _self.checkFilters;
            if (_self.show_other_locations) {
                var filters;
                if (projectLocation.length > 0) {
                    // When Any Location Selected
                    filters = _self.toQueryStringForOtherLocations(projectLocation);
                } else {
                    // When No Location Selected
                    filters = null;
                }
                await _self.getOtherLocation(filters);
            }

            await _self.fetchRecords(null, allParams);

            await _self.fetchProjects(allParams);
            
            _self.getBanners();
        })
        _self.removeCompareFromBucket();
        // document.addEventListener('DOMContentLoaded', async () => {
        window.addEventListener('searchPageFiltersEvent', async (event) => {

            _self.show_other_locations = _self.checkFilters;
            if (event.detail.projectOrLocationSelection.length > 0) {
                var filters = _self.toQueryStringForOtherLocations(event.detail.projectOrLocationSelection);
                this.title = event.detail.projectOrLocationSelection[0];

                _self.getOtherLocation(filters);
            } else {
                this.title = 'UAE';
                _self.getOtherLocation();

            }
            _self.fetchRecords(null, event.detail);
            _self.fetchProjects(event.detail);
        })
        // })
        _self.$watch('loadingMapPins', async (newVal) => {
            _self.clearMapMarkers();
        })
        _self.$watch('expandOnMobile', async (newVal) => {
            if (newVal) {
                window.body.classList.add('modal-open');
                window.html.classList.add('modal-open');
            } else {
                window.body.classList.remove('modal-open');
                window.html.classList.remove('modal-open');
            }
        })

        _self.$watch('selectedProject', async (_project) => {
            const allParams = this.getQueryStrings();

            if (_project) {
                for (let key in allParams) {
                    if (key.startsWith("projectOrLocationSelection")) {
                        delete allParams[key];
                    }
                }
                allParams.selectedProjects = _project ? _project : allParams;
            }
            await this.fetchRecords(null, allParams);
        })

        _self.$watch('results', async (value, oldValue) => {


            const properties = value.data.map(x => x.id);
            const result = manageBuyPagePropertyIds(properties);

            if ((JSON.parse(JSON.stringify(value))?.meta?.total != JSON.parse(JSON.stringify(oldValue))?.meta?.total)) {
                setTimeout(async () => {
                    if (value?.meta?.total < 5) {
                        await _self.getRecommendations({ 'propertiesIds': properties });
                    } else {
                        _self.recommendation = [];
                    }
                }, 0);
            }

            if (result.Newly_Added_IDs.length > 0) {
                await axios.post(`/${window.global.country_code}/track-property-impression`, {
                    'properties': result.Newly_Added_IDs
                }).then((result) => { }).catch((err) => { });
            }
        })

        _self.initializeMap();
    },
    async fetchFeaturedListing() {
        await axios.get('/api/local/search-featured').then((result) => {
            console.log(result.data,'sadasdsads');
            this.featuredProperty = result.data ?? null;
        }).catch(error => {
            console.log(error);
        })
    },
    get getPagination() {
        let links = this.results?.meta?.links;
        let prev = links.find(l => l.label === 'Previous');
        let next = links.find(l => l.label === 'Next');
        let numeric = links.filter(l => !isNaN(l.label));

        let total = this.results.meta.last_page;
        let current = this.results.meta.current_page;

        let result = [];

        // --- Previous button ---
        if (prev) result.push(prev);

        // --- Case 1: only 1 page ---
        if (total === 1) {
            result.push(numeric[0]);
        }
        // --- Case 2: 2 pages ---
        else if (total === 2) {
            result.push(...numeric);
        }
        // --- Case 3: up to 5 pages (just show all) ---
        else if (total <= 5) {
            result.push(...numeric);
        }
        // --- Case 4: more than 5 pages ---
        else {
            // Always show first page
            result.push(numeric[0]);

            // Add dots if needed
            if (current > 3) {
                result.push({ label: '...', url: null, active: false });
            }

            // Add current -1, current, current +1 (if valid)
            let start = Math.max(2, current - 1);
            let end = Math.min(total - 1, current + 1);

            for (let i = start; i <= end; i++) {
                result.push(numeric.find(l => Number(l.label) === i));
            }

            // Add dots if needed
            if (current < total - 2) {
                result.push({ label: '...', url: null, active: false });
            }

            // Always show last page
            result.push(numeric[numeric.length - 1]);
        }

        // --- Next button ---
        if (next) result.push(next);
        this.scrollToTop();
        return result;

    },
    scrollToTop() {
        let map_properties = document.getElementById('map-properties')
        window.scrollTo(0, 0);
        if (map_properties) {
            map_properties.scrollTo(0, 0);
        }

        if ($('.map-container-17').length > 0) {
            let mapView = document.getElementsByClassName('map-container-17')[0];


            window.scrollTo(0, 0);
            if (mapView) {
                mapView.scrollTo(0, 0);
            }
        }

    },
    get checkFilters() {
        var obj = this.getQueryStrings();
        // Check if any other filter besides projectOrLocationSelection has value
        const otherSelected = Object.entries(obj).some(([key, value]) => {
            if (key.startsWith("projectOrLocationSelection") || key.startsWith("selectedOrder")) return false;
            if (Array.isArray(value)) return value.length > 0;
            return value !== "" && value !== null && value !== undefined;
        });

        if (otherSelected) return false;

        // If only projectOrLocationSelection or nothing is selected → true
        return true;
    },
    initializeMap() {
        const mapKey = window.global.map_key;
        var scr = document.createElement("script");
        scr.type = "text/javascript";
        scr.src = 'https://maps.googleapis.com/maps/api/js?key=' + mapKey + '&libraries=drawing&v=weekly&callback=loadedSearchMap&loading=async';
        scr.innerHTML = null;
        document.body.appendChild(scr);

        window.loadedSearchMap = this.loadedSearchMap.bind(this);
    },
    async loadedSearchMap() {
        const { Map } = await google.maps.importLibrary("maps");
        mapContainer = new Map(document.getElementById('mapContainer'), {
            center: { lat: 25.1257993, lng: 55.2476467 }, // Example coordinates
            zoom: 11,
            clickableIcons: false,
            gestureHandling: 'greedy',
            zoomControlOptions: {
                position: window.innerWidth > 768 ? google.maps.ControlPosition.LEFT_BOTTOM : google.maps.ControlPosition.LEFT_CENTER,
            },
            zoomControl: true,
            disableDefaultUI: true,
            mapId: window.global.map_key,

        });

        markerClusterer = new window.markerClusterer.MarkerClusterer({
            map: mapContainer,
            markers: [],
            renderer: {
                render: ({ count, position }) => {
                    const clusterIcon = document.createElement("div");
                    clusterIcon.style.width = "60px";
                    clusterIcon.style.height = "60px";
                    clusterIcon.style.backgroundImage = "url('/images/icons/cluster.png')";
                    clusterIcon.style.backgroundSize = "cover";
                    clusterIcon.style.display = "flex";
                    clusterIcon.style.alignItems = "center";
                    clusterIcon.style.justifyContent = "center";
                    clusterIcon.style.color = "#2D2B2B";        // label color
                    clusterIcon.style.fontSize = "14px";     // label size
                    clusterIcon.style.fontWeight = "medium";   // label weight
                    clusterIcon.style.borderRadius = "50%";  // if your PNG is circular

                    clusterIcon.textContent = count;

                    return new google.maps.marker.AdvancedMarkerElement({
                        position,
                        content: clusterIcon,
                        zIndex: Number(count), // ensures bigger clusters stay on top
                    });
                }
            }
        });
    },
    removeCompareFromBucket() {
        var _this = this;
        document.addEventListener('DOMContentLoaded', function () {
            window.addEventListener('removeCompareFromBucket', function (event) {
                var id = event.detail.data;
                let index = _this.results.data.findIndex(x => x.id == id);
                if (index != -1) {
                    _this.results.data[index].is_compare = false;
                }
            });
        });
    },

    get visibleOtherLocationsItems() {
        return this.expanded ? this.other_locations : this.other_locations.slice(0, this.limit);
    },
    get mapView() {
        return this.type == 'map';
    },
    get pageTitle() {
        return `Properties for Sale`;
        // return `Properties for Sale in ${this.title || 'UAE'}`;
    },
    getQueryStrings(key = null) {
        const query = window.location.search;
        const params = new URLSearchParams(query);
        if (key) {
            return params.getAll(key); // when get only
        }
        return Object.fromEntries(params.entries()); // all parameters
    },
    async handleSortFilter($event) {
        let selectedOrder = $event?.detail?.value;
        Livewire.emit('refreshComponent', selectedOrder)
        const allParams = this.getQueryStrings();
        allParams.selectedOrder = selectedOrder;
        if (this.selectedProject && this.selectedProject.length) {
            allParams.selectedProjects = this.selectedProject;
        }
        this.fetchRecords(null, allParams);
    },
    async handleNewTabSearch(title) {
        const projectOrLocationSelection = $('#projectOrLocationSelection, #mobileProjectOrLocationSelection1');
        projectOrLocationSelection.empty();
        const isUAE = title === 'UAE';
        const location = isUAE
            ? null
            : { id: '231', text: title };

        // Dispatch event
        window.dispatchEvent(
            new CustomEvent('handle-other-location-search', {
                detail: { locations: location },
            })
        );
        if (location) {
            window.dispatchEvent(
                new CustomEvent('handleOtherLocationSearch', {
                    detail: location.text,
                })
            );
        }

        // Update dropdown if not UAE
        this.title = title;
        if (!isUAE) {
            const option = new Option(title, title, true, true);
            projectOrLocationSelection.append(option);
            this.expandOnMobile = false;
        }

        const filters = !isUAE ? this.toQueryStringForOtherLocations([title]) : null;

        let recordFilters = this.getQueryStrings();
        if (!isUAE) {
            for (let key in recordFilters) {
                if (key.startsWith("projectOrLocationSelection")) {
                    delete recordFilters[key];
                }
            }
            recordFilters.projectOrLocationSelection = [title];
        } else {
            Livewire.emit('resetForm')
        }
        // Prepare filters

        recordFilters = isUAE ? null : recordFilters;
        // Execute requests
        await Promise.all([
            this.getOtherLocation(filters),
            this.fetchRecords(null, recordFilters),
        ]);

        await this.fetchProjects(recordFilters);
    },
    toQueryStringForOtherLocations(arr, keyName = "data") {

        return {
            [keyName]: arr.map((item, index) => ({
                id: index + 1,
                text: item
            }))
        };

    },
    async getOtherLocation(filters = null) {
        var api = '/api/local/get-states-locations?countryId=' + window.global.country_id;
        if (filters !== null) {
            api = '/api/local/get-other-locations';
        }
        this.otherLocationLoading = true;
        await axios.get(api, {
            params: filters
        }).then(res => {
            this.otherLocationLoading = false;
            this.other_locations = res.data[0] ?? [];
        }).catch((err) => {
            this.otherLocationLoading = false;
        })
    },
    async fetchRecords(url = null, filters = null) {
        return new Promise(async (resolve, reject) => {
            this.loading = true;
            await axios.get(url ? url : `/api/local/search-properties`, {
                params: { ...filters, ...{ 'user_id': window.global.user_id,'country_code': window.global.country_code } }
            }).then(res => {
                this.loading = false;
                this.results = res.data;
                resolve(res.data);
            }).catch((err) => {
                reject(false);
                this.loading = false;
            })
        })
    },
    async getRecommendations(filters = null) {

        await axios.get(`/api/local/recommendation-properties`, {
            params: { ...filters, ...{ 'user_id': window.global.user_id } }
        }).then(res => {

            this.recommendation = res.data;
        }).catch((err) => {

        })
    },
    getBanners() {
        axios.get('/api/banners', {
            params: {
                position: [5, 6, 7]
            }
        }).then(({ data }) => {
            this.banners = data;
        }).catch((err) => {
            console.log(err);

        })
    },
    async fetchProjects(filters = null) {
        if (this.results.data.length > 0) {
            this.loadingMapPins = true;
            await axios.get(`/api/local/search-project-pins`, {
                params: { ...filters, ...{ 'user_id': window.global.user_id } }
            }).then(res => {
                this.mapPins = res.data;
                this.loadingMapPins = false;
                this.updateMapData();
            }).catch((err) => {
                if (err.response.status == 404) {
                    mapContainer.setZoom(11)
                    this.clearMapMarkers();
                    this.loadingMapPins = false;
                    this.closeMap();
                }
            })

        }
    },
    getBanner(position) {
        return this.banners.find((x) => x.position == position);
    },
    clearMapMarkers() {
        return new Promise((resolve, reject) => {
            if (markers.length > 0) {
                for (var i = 0; i < markers.length; i++) {
                    markers[i].setMap(null);
                }
                markers = [];
            }
            if (markerClusterer && markerClusterer.hasOwnProperty("map")) {
                markerClusterer.clearMarkers();
            }
            return resolve(true);
        });
    },
    async updateMapData() {
        if (typeof mapContainer != 'undefined') {
            const center = await this.calculateCenter();
            await mapContainer.setCenter(center);
            if (markers.length > 0) {
                await this.clearMapMarkers();
            }
            await this.setMarkers();
        }
        if (this.selectedProject != null) {
            this.selectedProject = null;
        }
    },
    calculateCenter() {
        let totalLat = 0;
        let totalLng = 0;

        this.mapPins.forEach(pin => {
            totalLat += parseInt(pin.latitude);
            totalLng += parseInt(pin.longitude);
        });

        const centerLat = totalLat / this.mapPins.length;
        const centerLng = totalLng / this.mapPins.length;

        return { lat: centerLat, lng: centerLng };
    },
    setMarkers() {


        markers = [];
        let selectedMarker = null;
        const bounds = new google.maps.LatLngBounds();
        this.mapPins.map(async (project) => {

            let title = project.title;
            if (project.title.length > 17) {
                title = project.title.slice(0, 15) + '...';
            }

            let priceTagSvg = encodeSVG(tagSvgRaw(project.properties_formatted_price, title, project.properties_count));
            let priceTagSvgClick = encodeSVG(clickMarkerSVG(project.properties_formatted_price, title, project.properties_count));

            var markerElement = document.createElement('img');
            markerElement.src = priceTagSvg;

            var position = {
                lat: parseFloat(project.latitude),
                lng: parseFloat(project.longitude)
            };

            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

            var marker = new AdvancedMarkerElement({
                position: position,
                content: markerElement,
                title: project.title,
                gmpClickable: true,
            });

            // store default and clicked icons on the marker
            marker.defaultIcon = priceTagSvg;
            marker.clickedIcon = priceTagSvgClick;

            markerElement.addEventListener("click", () => {
                if (this.loading) {
                    return;
                }

                // reset previously selected marker
                if (selectedMarker && selectedMarker !== marker) {
                    selectedMarker.content.src = selectedMarker.defaultIcon;
                }

                if (selectedMarker !== marker) {
                    // select this marker
                    markerElement.src = marker.clickedIcon;
                    selectedMarker = marker;
                    this.filterMarkerProject(marker, project);
                } else {
                    // deselect same marker
                    this.filterMarkerProject(marker, null);
                    markerElement.src = marker.defaultIcon;
                    selectedMarker = null;
                }
            });
            markers.push(marker);
            markerClusterer.addMarker(marker);
            bounds.extend(marker.position);

        });
        setTimeout(() => {
            if (markers.length === 1) {
                mapContainer.setCenter(markers[0].position);
                mapContainer.setZoom(15); // optional, you can change this
            } else if (markers.length > 1) {
                mapContainer.fitBounds(bounds);
            }
        }, 0);
    },
    closeAll() {
        this.openPropertyModal = false;
        this.updateMapData();
    },
    openMap() {
        this.clearMapMarkers();
        setTimeout(() => {
            this.updateMapData();
            this.type = 'map';
            $('.main_div_search_page').removeClass('container');
            $('.main_div_search_page').addClass('container-fluid');
            $('#footer').hide();
            window.body.classList.add('modal-open');
            window.html.classList.add('modal-open');
        }, 0);
    },

    closeMap() {
        setTimeout(() => {
            this.type = 'list';
            if (this.selectedProject != null) {
                this.loading = false;
                this.selectedProject = null;
            }
            $('.main_div_search_page').addClass('container');
            $('.main_div_search_page').removeClass('container-fluid');
            $('#footer').show();
            window.body.classList.remove('modal-open');
            window.html.classList.remove('modal-open');
        }, 200);
    },
    filterMarkerProject(marker, project = null) {
        this.selectedProject = project != null ? [project.id] : null;
        if (window.innerWidth < 768) {
            this.openPropertyModal = true;
        }
    },
    showProperties($event) {
        const pageSize = $event.target.value;
        var filters = this.getQueryStrings();
        filters.pageSize = pageSize;
        this.fetchRecords(null, filters);
    },
    openLikePropertyModal(id) {
        if (!window.global.user_id) {
            const login = document.getElementById('login_modal_button').click()
            return;
        }
        Livewire.emit('openLikePopup', id);
        var _this = this
        window.addEventListener('likeResponseReceived', function (event) {
            var responseData = event.detail.data;
            // Use the response data in your JavaScript logic
            let index = _this.results.data.findIndex(x => x.id == responseData?.id);
            if (index != -1) {
                _this.results.data[index].is_liked = true;
            }
        });
    },
    unLikeProperty(id) {
        axios.delete(window.global.base_url + '/' + window.global.country_code + '/unlike-property-map', {
            params: {
                'user_id': window.global.user_id,
                'property_id': id
            }
        }).then((response) => {
            body.classList.remove('modal-open');
            let index = this.results.data.findIndex(x => x.id == response.data.data.property_id);
            this.results.data[index].is_liked = false;
            // this.alert('success', response.data.message);
        }).catch((error) => {
            body.classList.remove('modal-open');
        })

    },
}));

Alpine.data('WhatsAppButton', () => ({
    redirectWhatsapp(property) {
        return redirectToWhatsapp(property);
    }
}));

var requestQueue = Promise.resolve();
Alpine.data('ListingCard', () => ({
    showLocation: true,
    makePhoneCall(number) {
        window.location.href = 'tel:' + number;
        return;
    },
    handleCall(property, trackLeadUrl = null, sourceUrl = null) {
        if (window.isMobileScreen) {
            //generate lead and statistics            
            if (trackLeadUrl) {// only call API if URL exists
                axios.post(trackLeadUrl, {
                    entity: 'property',
                    reference: property?.reference_id,
                    type: 'call',
                    event: 'click',
                    source: sourceUrl,
                }).catch(err => console.error(err));
            }
            //now open keypad for call
            this.makePhoneCall(property?.mobile_number);
            return;
        }
        Livewire.emit('openCallPopup', {
            id: property?.id,
            type: 'property',
            image: property?.images.length > 0 ? property?.images[0] : '/images/placeholder.png',
        });
    },
    async redirectWhatsapp(property) {
        return redirectToWhatsapp(property);
        // await Livewire.emit('WhatsAppClicked', property?.id);
        // const link = property.whatsapp_inquiry_text;
        // setTimeout(() => {
        //     // Open WhatsApp in a new tab
        //     const newTab = window.open(link, '_blank');
        //     // Fallback if popup is blocked
        //     if (!newTab) {
        //         window.location.href = whatsappUrl; // force redirect
        //     }
        // }, 0);
    },
    limitLetters(text, limit) {
        if (!text) return text;
        return text.length > limit ? text.substring(0, limit) + "..." : text;
    },
    handleEmail(property) {
        Livewire.emit('openEmailPopup', {
            'id': property?.id,
            'image': property?.images.length > 0 ? property?.images[0] : '/images/placeholder.png',
            'developer': property?.developer_id,
            'type': 'property'
        });
    },

    // Define a simple async queue
    // requestQueue: Promise.resolve(),
    async addToCompareArray($event, property) {
        let id = property?.id;
        let isChecked = $event.target.checked;

        // Push into the queue
        requestQueue = requestQueue.then(async () => {
            try {
                if (isChecked) {
                    await axios.get(`add-to-compare-array/${id}`);
                    await this.clickProperty(id);

                    Livewire.emitTo('manage-compare', '$refresh');
                    Livewire.emitTo('count-compared-properties', '$refresh');

                    // Animation after a small delay
                    setTimeout(async () => {
                        await this.handleAnimation($event.target, property);
                    }, 500);

                } else {
                    await axios.get(`remove-from-compare-array/${id}`);

                    Livewire.emitTo('manage-compare', '$refresh');
                    Livewire.emitTo('count-compared-properties', '$refresh');
                }
            } catch (err) {
                // console.log(err.response);
            }
        });
    },
    clickProperty(propertyId) {
        axios.post('/api/local/property-click', {
            property_id: propertyId
        }).then((result) => {
            // console.log(result, 'result');
        }).catch((err) => {
            // console.log(err, 'err');
        });
    },
    handleAnimation(btn, property) {
        $('.compare-counter').addClass('animate-bounce');
        $('.compare-counter').addClass('duration-3000');
        setTimeout(() => {
            $('.compare-counter').removeClass('animate-bounce');
            $('.compare-counter').removeClass('duration-3000');
        }, 3000);
    },



}));


Alpine.store('SearchSort', {
    sort: 'default',
    handleDropdown(value) {
        this.sort = value;
    }
});